import React from 'react';
import { useTranslation } from 'react-i18next';
import { DateUtils } from '../../../utils';
import Field from './Field';
import { FieldType } from '../../../models';
import { DatesFragment } from '../MobileFragments';
import { ConnectedSegmentDate } from '../Segment/SegmentDate';
import { ErrorUtils } from '../../../utils/ErrorUtils';
import { useSegmentContext } from '../Segment/SegmentManager/Context';

export const DateField = () => {
    const { t } = useTranslation();
    const placeholder = t('flightsManager.placeholder.date.main');
    // TODO: update when format is clarified from UX
    const dateFormat = t('calendar.dateFormatOneLiner');
    const getFormattedDate = (value) => (value ? DateUtils.formatDate(value, dateFormat) : '');
    const getErrorMessage = (error) =>
        t(ErrorUtils.getDatesErrorKey(error), ErrorUtils.getDatesErrorKeyArgs(error));
    const { segment } = useSegmentContext();
    const { id } = segment;
    return (
        <ConnectedSegmentDate segmentId={id}>
            {({ error, value }) => (
                <React.Fragment>
                    <Field
                        icon="calendar"
                        id={FieldType.DATE}
                        placeholder={placeholder}
                        value={getFormattedDate(value)}
                        errorMessage={getErrorMessage(error)}
                    />
                    <DatesFragment />
                </React.Fragment>
            )}
        </ConnectedSegmentDate>
    );
};
